import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Constants } from './constants';

// If we come in need of many custom validators perhaps we should consider using a library like ngx-validators
// https://github.com/Nightapes/ngx-validators

export class CustomValidators {
  static confirm(field: string, confirmField: string): ValidatorFn {
    const validator = (group: FormGroup): { [key: string]: any } => {
      const fieldControl = group.controls[field];
      const confirmationControl = group.controls[confirmField];

      if (fieldControl.value !== confirmationControl.value) {
        confirmationControl.setErrors(Object.assign({}, confirmationControl.errors, { confirm: true }));
      } else if (confirmationControl.hasError('confirm')) {
        const errors = confirmationControl.errors || {};
        delete errors['confirm'];
        confirmationControl.setErrors(errors);
      }

      return {};
    };
    return validator as any;
  }

  // https://www.w3.org/TR/html5/forms.html#valid-e-mail-address
  static email(control: AbstractControl): { [key: string]: boolean } {
    if (!control.value) {
      return {};
    }
    // eslint-disable-next-line max-len
    const pattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    if (pattern.test(control.value)) {
      return {};
    }
    return { email: true };
  }

  static phone(control: AbstractControl): { [key: string]: boolean } {
    if (!control.value) {
      return {};
    }

    const val: string = control.value;
    if (val.replace(/\D+/g, '').length !== Constants.PHONE_DIGITS) {
      return { phone: true };
    }

    return {};
  }

  static noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { required: true };
  }

  /**
   * Prevent non-allowed symbols for number input fields.
   * The allowed symbols are: digits (0-9), backspace, delete, arrow keys,
   * tab, enter, decimal point, and comma.
   *
   * @param e - The keyboard event triggered by keypress.
   */
  public preventNonAllowedSymbolsForNumberInputs(e: KeyboardEvent) {
    // List of allowed keys: digits, control keys (backspace, delete, arrow keys, tab, enter), decimal point, and comma
    const allowedKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
      'Enter',
      '.',
      ',',
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
    ];

    // Check if the key pressed is in the list of allowed keys
    const isAllowed = allowedKeys.includes(e.key);

    // If the key pressed is not allowed, prevent the default action (i.e., entering the character)
    if (!isAllowed) {
      e.preventDefault();
    }
  }

  public onPastePreventDefault(e: any) {
    e.preventDefault();
  }

  static capitalLetterValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: string = control.value || '';
      return /[A-Z]/.test(value) ? null : { capitalLetter: true };
    };
  }

  static digitValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: string = control.value || '';
      return /\d/.test(value) ? null : { digit: true };
    };
  }
}
